import { render, staticRenderFns } from "./CaseRelatedCases.vue?vue&type=template&id=967c01ec&"
import script from "./CaseRelatedCases.vue?vue&type=script&lang=js&"
export * from "./CaseRelatedCases.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports